import { useStytch } from '@stytch/nextjs';
import { useState } from 'react';

import theraToast from 'components/generic-components/toast/TheraToast';
import { AuthRoutes } from 'routes';

export const useStytchVerifyEmail = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}): {
  sendVerificationEmail: (emailAddress: string) => Promise<void>;
  isSending: boolean;
} => {
  const [isSending, setIsSending] = useState(false);
  const stytch = useStytch();
  const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

  const sendVerificationEmail = async (emailAddress: string) => {
    if (!emailAddress) return;
    if (isSending) return;
    setIsSending(true);
    stytch.magicLinks.email
      .send(emailAddress, {
        login_magic_link_url: origin + AuthRoutes.Authenticate + '?email=' + encodeURIComponent(emailAddress),
        login_expiration_minutes: 60 * 24 * 7,
        login_template_id: 'email_verification',
      })
      .then((_response) => {
        console.info('Verification Email sent!', _response);
        onSuccess?.();
      })
      .catch((_reason) => {
        theraToast.error({
          message: 'Failed to send email verification link',
          error: _reason,
          options: {
            id: 'email-sending-failed',
          },
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return {
    sendVerificationEmail,
    isSending,
  };
};

export default useStytchVerifyEmail;
